<template>
  <div class="hidden hvh-flex align-center font-sm no-line-height">
    <v-icon class="ml-1" color="white" small>mdi-checkbox-marked-circle</v-icon>
    <span class="ml-1">Private: This cohort is only visible to you</span>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.hidden {
  background: linear-gradient(90deg, #7f8285 0%, #8e9192 100%);
  color: #ffffff;
  font-weight: 600;
  letter-spacing: 0.2px;
  padding: 1px 1px 0 1px;
}
</style>